import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 relative overflow-hidden flex items-center justify-center text-center" data-id="element-44">
      {/* Background Gradients */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050510] to-[#0a0a1f] z-0" data-id="element-45" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-cyan-500/10 rounded-full blur-[120px] animate-pulse" data-id="element-46" />

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-47">
        <ScrollReveal data-id="element-48">
          <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-49">
            Hoy puedes seguir consumiendo contenido... <br data-id="element-50" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-400" data-id="element-51">
              o empezar a construir ingresos.
            </span>
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-52">
          <p className="text-2xl text-white mb-10 font-medium" data-id="element-53">
            La decisión es tuya.
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-54">
          <div className="glass-card p-8 md:p-12 rounded-3xl inline-block w-full max-w-2xl border border-cyan-500/30 shadow-[0_0_60px_rgba(0,212,255,0.15)]" data-id="element-55">
            <div className="flex flex-col items-center gap-6" data-id="element-56">
              <div className="flex items-baseline gap-3" data-id="element-57">
                <span className="text-gray-500 line-through text-2xl" data-id="element-58">$97</span>
                <span className="text-5xl md:text-6xl font-bold text-white tracking-tight" data-id="element-59">
                  $16.39
                </span>
              </div>

              <CTAButton text="EMPEZAR AHORA" size="lg" fullWidth className="text-xl py-5" data-id="element-60" />

              <div className="flex items-center gap-4 text-sm text-gray-400 mt-2" data-id="element-61">
                <span className="flex items-center gap-1" data-id="element-62">🔒 Pago Seguro</span>
                <span className="w-1 h-1 bg-gray-600 rounded-full" data-id="element-63" />
                <span className="flex items-center gap-1" data-id="element-64">
                  ⚡ Acceso Inmediato
                </span>
              </div>
            </div>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}